<template>
<v-card class="ma-2" outlined>

    <v-card-text class="pa-2">
        <v-row no-gutters>

            <v-col cols="12" md="3">
                <v-autocomplete label="Cauta o localitate" autocomplete="false" :loading="loadingPlaces" :items="places" item-text="name" item-value="id" v-model="c_place" :search-input.sync="query" class="ma-1" return-object clearable cache-items
                    hide-no-data hide-details outlined>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
                <im-range :check_in.sync="c_check_in" :check_out.sync="c_check_out" />
            </v-col>

            <v-col cols="12" md="2">
                <im-guests :rooms.sync="c_rooms" />
            </v-col>

            <v-col cols="12" md="1">
                <v-select v-model="c_currency" class="ma-1" outlined :items="['RON','EUR']" type="currency" label="Valută" menu-props="offsetY" hide-details />
            </v-col>

            <v-col cols="12" md="2">
                <div class="ma-1">
                    <v-btn class="primary" depressed block style="height: 56px;" @click="emitSearch()">
                        <v-icon>mdi-magnify</v-icon>
                        Caută
                    </v-btn>
                </div>
            </v-col>

        </v-row>
    </v-card-text>

</v-card>
</template>

<script>
import IMRange from "@/components/utils/IMRange";
import IMGuests from "@/components/utils/IMGuests";
import {
    getPlacesByQuery
} from "@/api/Places";

export default {

    components: {
        'im-range': IMRange,
        'im-guests': IMGuests,
    },

    props: {
        place_id: {
            type: String,
            default: () => null
        },
        check_in: {
            type: String,
            default: () => null
        },
        check_out: {
            type: String,
            default: () => null
        },
        rooms: {
            type: Array,
            default: () => null,
        },
        currency: {
            type: String,
            default: () => 'RON'
        }
    },

    data: () => ({
        loading: false,
        loadingPlaces: false,
        places: [],
        query: null,
    }),

    computed: {
        c_place: {
            get() {
                return this.places.find(place => this.place_id === place.id) || null;
            },
            set(val) {
                this.$emit("update:place_id", val.id);
            }
        },
        c_check_in: {
            get() {
                return this.check_in;
            },
            set(val) {
                this.$emit("update:check_in", val);
            }
        },
        c_check_out: {
            get() {
                return this.check_out;
            },
            set(val) {
                this.$emit("update:check_out", val)
            }
        },
        c_rooms: {
            get() {
                return this.rooms;
            },
            set(val) {
                this.$emit("update:rooms", val)
            }
        },
        c_currency: {
            get() {
                return this.currency;
            },
            set(val) {
                this.$emit("update:currency", val)
            }
        }
    },

    methods: {
        emitSearch() {
            this.$emit('search');
        },

        querySelections(v) {
            this.loadingPlaces = true;
            getPlacesByQuery(v)
                .then(({
                    data
                }) => {
                    /** response.data.data **/
                    let {
                        data: places
                    } = data;
                    this.places = places.filter(e => {
                        return (e.name || '')
                            .toLowerCase()
                            .indexOf((v || '')
                                .toLowerCase()) > -1;
                    });
                })
                .finally(() => this.loadingPlaces = false);
        },
    },

    watch: {
        query(val) {
            let alreadySelected = (this.c_place) ? this.c_place.name : '';
            if(val && val.length > 2 && val !== alreadySelected) this.querySelections(val);
        },
    },

}
</script>
